export const isLoggedIn = (state) => {
    return state.userData ? true : false;
};

export const isAuthReady = (state) => {
    return state.authReady;
};

